import React from 'react';

import LevelFilter from './LevelFilter.jsx';

var FilterOptions = React.createClass({

    getInitialState: function() {

        var QCF = this.props.QCFLevels;
        var SCQF = this.props.SCQFLevels;
        
        return({
            expanded : false,
            TextAgainst : [
                { id : 'Classification Names', selected : true },
                { id : 'Subject Names', selected : true }
            ],
            QCF: [
                { id: 1, selected: QCF.indexOf(1) < 0 ? true : false },
                { id: 2, selected: QCF.indexOf(2) < 0  ? true : false  },
                { id: 3, selected: QCF.indexOf(3) < 0 ? true : false  },
                { id: 4, selected: QCF.indexOf(4) < 0 ? true : false  },
                { id: 5, selected: QCF.indexOf(5) < 0 ? true : false  },
                { id: 6, selected: QCF.indexOf(6) < 0 ? true : false  },
                { id: 7, selected: QCF.indexOf(7) < 0 ? true : false  },
                { id: 8, selected: QCF.indexOf(8) < 0 ? true : false  }
            ],
            SCQF: [
                { id: 1, selected: SCQF.indexOf(1) < 0 ? true : false  },
                { id: 2, selected: SCQF.indexOf(2) < 0 ? true : false  },
                { id: 3, selected: SCQF.indexOf(3) < 0 ? true : false  },
                { id: 4, selected: SCQF.indexOf(4) < 0 ? true : false  },
                { id: 5, selected: SCQF.indexOf(5) < 0 ? true : false  },
                { id: 6, selected: SCQF.indexOf(6) < 0 ? true : false  },
                { id: 7, selected: SCQF.indexOf(7) < 0 ? true : false  },
                { id: 8, selected: SCQF.indexOf(8) < 0 ? true : false  },
                { id: 9, selected: SCQF.indexOf(9) < 0 ? true : false  },
                { id: 10, selected: SCQF.indexOf(10) < 0 ? true : false  },
                { id: 11, selected: SCQF.indexOf(11) < 0 ? true : false  },
                { id: 12, selected: SCQF.indexOf(12) < 0 ? true : false  }
            ]
        })
    },

    render: function(){

        var component = this;

        if ( this.state.expanded == false ) {

            return (
                <div className="filter--options clearfix">
                    <a href="#" className="filter--options--toggle" onClick={ this.toggle } >Refine by level</a>
                </div>
            );

        }

        else {

            var QCFs = this.state.QCF.map(function(d) {
                return (
                    <div className="filter__checkbox">
                        <input type="checkbox" key={d.id} checkedLink={this.linkCheckbox('QCF', d)} /> {d.id}
                    </div>
                );
            }.bind(this));

            var SCQFs = this.state.SCQF.map(function(d) {
                return (
                    <div className="filter__checkbox">
                        <input type="checkbox" key={d.id} checkedLink={this.linkCheckbox('SCQF', d)} /> {d.id}
                    </div>
                );
            }.bind(this));

            return (
                <div className="filter--options active clearfix">
                    <a href="#" className="filter--options--toggle active" onClick={ this.toggle } >X</a>
                    <div className="filter--display">
                        <div className="clearfix">
                            <form>
                                <fieldset>
                                    <legend>Include SCQF Levels : </legend>
                                    { SCQFs }
                                </fieldset>
                            </form>
                        </div>
                        <div className="clearfix">
                            <form>
                                <fieldset>
                                    <legend>Include RQF/CQFW Levels : </legend>
                                    { QCFs }
                                </fieldset>
                            </form>
                        </div>
                    </div>
                    <ResetAll
                        QCFLevels = { this.props.QCFLevels }
                        SCQFLevels = { this.props.SCQFLevels }
                        reset = { this.reset }
                    />
                    <ClearAll
                        QCFLevels = { this.props.QCFLevels }
                        SCQFLevels = { this.props.SCQFLevels }
                        clear = { this.clear }
                    />
                </div>
            );

        }

    },

    linkCheckbox: function(array, d) {

        if ( array == 'TextAgainst' ) {

            return {
                value: d.selected,
                requestChange: function(bool) {
                    this.changeTextAgainst(d.id,bool);
                }.bind(this)
            };

        }

        if ( array == 'QCF' ) {

            return {
                value: d.selected,
                requestChange: function(bool) {
                    this.changeQCF(d.id,bool);
                }.bind(this)
            };

        }

        if ( array == 'SCQF' ) {

            return {
                value: d.selected,
                requestChange: function(bool) {
                    this.changeSCQF(d.id,bool);
                }.bind(this)
            };

        }

    },

    changeTextAgainst: function( id, bool ) {

        this.setState({
            TextAgainst: this.state.TextAgainst.map(function(d) {
                var newSelected = (d.id === id ? bool : d.selected);
                return {id: d.id, selected: newSelected};
            })
        }, function(){
            this.handleChange()
        });

    },

    changeQCF: function( id, bool ) {

        this.setState({
            QCF: this.state.QCF.map(function(d) {
                var newSelected = (d.id === id ? bool : d.selected);
                return {id: d.id, selected: newSelected};
            })
        }, function(){

            function isFalse(obj) {
                return obj.selected == false;
            }

            this.handleChange({ QCF : this.state.QCF.filter(isFalse) })
        });

    },

    changeSCQF: function( id, bool ) {

        this.setState({
            SCQF: this.state.SCQF.map(function(d) {
                var newSelected = (d.id === id ? bool : d.selected);
                return {id: d.id, selected: newSelected};
            })
        }, function(){

            function isFalse(obj) {
                return obj.selected == false;
            }

            this.handleChange({ SCQF:this.state.SCQF.filter(isFalse) })
        });

    },

    toggle : function(e){

        e.preventDefault();

        if ( this.state.expanded == false ) this.setState({expanded: true});

        else if ( this.state.expanded == true ) this.setState({expanded: false});

    },
    
    reset : function(e){
        
        this.setState({
            QCF: [
                { id: 1, selected: true },
                { id: 2, selected: true },
                { id: 3, selected: true },
                { id: 4, selected: true },
                { id: 5, selected: true },
                { id: 6, selected: true },
                { id: 7, selected: true },
                { id: 8, selected: true }
            ],
            SCQF: [
                { id: 1, selected: true },
                { id: 2, selected: true },
                { id: 3, selected: true },
                { id: 4, selected: true },
                { id: 5, selected: true },
                { id: 6, selected: true },
                { id: 7, selected: true },
                { id: 8, selected: true },
                { id: 9, selected: true },
                { id: 10, selected: true },
                { id: 11, selected: true },
                { id: 12, selected: true }
            ]
        }, function(){
            this.handleChange('reset');
        });
        
    },

    clear : function(e){

        this.setState({
            QCF: [
                { id: 1, selected: false },
                { id: 2, selected: false },
                { id: 3, selected: false },
                { id: 4, selected: false },
                { id: 5, selected: false },
                { id: 6, selected: false },
                { id: 7, selected: false },
                { id: 8, selected: false }
            ],
            SCQF: [
                { id: 1, selected: false },
                { id: 2, selected: false },
                { id: 3, selected: false },
                { id: 4, selected: false },
                { id: 5, selected: false },
                { id: 6, selected: false },
                { id: 7, selected: false },
                { id: 8, selected: false },
                { id: 9, selected: false },
                { id: 10, selected: false },
                { id: 11, selected: false },
                { id: 12, selected: false }
            ]
        }, function(){
            this.handleChange('clear');
        });

    },

    handleChange: function(filtered) {
        this.props.onOptionChange(filtered);
    },

});

var ResetAll = React.createClass({

    render: function(){

        var component = this;

        if ( component.props.QCFLevels.length != 0 || component.props.SCQFLevels.length != 0 ) {
            return (
                <a href="#" className="reset--options" onClick={ this.reset } >Reset All</a>
            );
        }
        else {
            return (
                <a href="#" className="reset--options disabled">Reset All</a>
            );
        }
    },

    reset : function(e){
        e.preventDefault();
        this.props.reset();
    }

});

var ClearAll = React.createClass({

    render: function(){

        var component = this;

        if ( component.props.QCFLevels.length < 8 || component.props.SCQFLevels.length < 12 ) {
            return (
                <a href="#" className="clear--options" onClick={ this.clear } >Clear All</a>
            );
        }
        else {
            return (
                <a href="#" className="clear--options disabled">Clear All</a>
            );
        }
    },

    clear : function(e){
        e.preventDefault();
        this.props.clear();
    }

});


export default FilterOptions;

/*
 var TextAgainst = this.state.TextAgainst.map(function(d) {
 return (
 <div className="filter__checkbox">
 <input type="checkbox" key={d.id} checkedLink={this.linkCheckbox('TextAgainst', d)} /> {d.id}
 </div>
 );
 }.bind(this));

 <div className="clearfix">
 <form>
 <fieldset>
 <legend>Filter Text against : </legend>
 { TextAgainst }
 </fieldset>
 </form>
 </div>

 */


/** WEBPACK FOOTER **
 ** ./app/FilterOptions.jsx
 **/